import { render, staticRenderFns } from "./Dms.vue?vue&type=template&id=c284eb0a&"
import script from "./Dms.vue?vue&type=script&lang=js&"
export * from "./Dms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports